import Swal from "sweetalert2";
import Color from "../styles/Color";

/**
 * @func swalCondition
 * @desc sweetalert2 function helper
 * @author izeberg
 * @param {string} title - title ของ Sweetalert2 Popup ("title")
 * @param {string} message - message ของ Sweetalert2 Popup ("message")
 * @param {object} options -
 * @param {string} options.icon - icon ของ Sweetalert2 Popup (["error", "info", "question", "success", "warning"])
 * @param {string} options.iconColor - สีของ icon ("#00B0E1")
 * @param {boolean} options.showCancelButton - จะให้แสดงปุ่ม cancel ไหม (true or false)
 * @param {string} options.confirmButtonText - text ของปุ่ม confirm ("Confirm")
 * @param {string} options.cancelButtonText - text ของปุ่ม cancel ("Cancel")
 * @param {string} options.confirmButtonColor - สีของปุ่ม confirm ("#00B0E1")
 * @param {string} options.cancelButtonColor - สีของปุ่ม cancel ("#7C7C7C")
 * @param {Object} options.customClass - custom class
 * @param {Object} options.confirmCallback - custom class
 * @returns Sweetalert2 Popup
 */
export const swalCondition = async (title, message, options) => {
    return Swal.fire({
        heightAuto: false,
        icon: options?.icon || "",
        iconHtml: options?.iconHtml || "",
        iconColor: options?.iconColor || Color.primary,
        title,
        text: message,
        showCancelButton: options?.showCancelButton === true ? true : options?.showCancelButton !== false,
        confirmButtonText: options?.confirmButtonText || "Confirm",
        cancelButtonText: options?.cancelButtonText || "Cancel",
        confirmButtonColor: options?.confirmButtonColor || Color.primary,
        cancelButtonColor: options?.cancelButtonColor || "#7C7C7C",
        customClass: options?.customClass || {},
    }).then(result => {
        if (result.isConfirmed) {
            if (options?.confirmCallback) {
                options.confirmCallback();
            }
            return true;
        }
        return false;
    });
};
/** End @func swalCondition */
